export default __webpack_public_path__ + "media/components/Pages/Abitur/Images/How/6-5a8fdca7d61b956aa93fd1876e61b37b.svg";